import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2 3.333v5.334a6 6 0 1 0 12 0V3.333a2 2 0 0 0-2-2h-.667a2 2 0 0 0-2 2v5.334a1.333 1.333 0 1 1-2.666 0V3.333a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2m2-.666a.667.667 0 0 0-.667.666v1.334h2V3.333a.667.667 0 0 0-.666-.666zm1.333 6V6h-2v2.667a4.666 4.666 0 1 0 9.334 0V6h-2v2.667a2.667 2.667 0 0 1-5.334 0m5.334-4h2V3.333A.667.667 0 0 0 12 2.667h-.667a.667.667 0 0 0-.666.666z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })